import { ProfileChangeEmailDialog } from './profile-change-email-dialog';
import { DIALOG } from '../dialog-combiner';
import { transitions } from '../transition.config';
import { userModals } from 'core/User/modal.config';

DIALOG.add(userModals.PROFILE_CHANGE_EMAIL, {
  component: ProfileChangeEmailDialog,
  transition: transitions.SLIDE_UP,
  anchor: 'portal',
});
